import { PaginatedResults } from '../../../overviews/generic-overview/components/pagination/entities/paginated-results.entity';
import { ResponsePaginationInfo } from '../../../overviews/generic-overview/components/pagination/entities/pagination-info.entity';
import { Paginated } from '../../common/entities/mediahaven-api/paginated.entity';
import { ApiFragment } from '../../records/entities/api-fragment.class';
import { Metadata } from '../../records/entities/metadata/metadata.entity';

export function ParsePaginatedMetadataResponse(
    apiResponse: Paginated<Metadata>,
    resultsPerPage: number
): PaginatedResults<ApiFragment> {
    const paginationInfo: ResponsePaginationInfo = {
        totalNumberOfResults: apiResponse.TotalNrOfResults,
        page: apiResponse.StartIndex / Number(resultsPerPage),
        resultsPerPage: Number(resultsPerPage)
    };

    return {
        paginationInfo,
        results: apiResponse.Results.map(metadata => new ApiFragment(metadata))
    };
}
